module.exports = __webpack_public_path__ + "static/media/ovary.588ea903.svg";